const getCookieValue = (cookieName: string) => {
    if (typeof window === 'undefined') {
        return '';
    }
    const cookieString = document?.cookie
        ?.split('; ')
        .find(row => row.startsWith(`${cookieName}=`));
    return cookieString ? cookieString.split('=')[1] : '';
};

export default getCookieValue;